/* -------------- Base layout -------------- */
.message {
  display: flex;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-radius: var(--fdt-core-borderradius-medium);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  align-items: center;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.message__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.message__text {
  flex: 1 1 auto;
}
.message .message__text--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.message__actions {
  flex-shrink: 0;
  display: flex;
  gap: 0.5rem;
}
.message--fade-out {
  opacity: 0;
  transform: translateY(-10px);
}
.message__close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

@keyframes downloadToasterSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.message__icon--spinning-loader {
  background: radial-gradient(farthest-side, var(--fdt-semantic-color-background-primary) 94%, rgba(0, 0, 0, 0)) top/8px 8px no-repeat, conic-gradient(rgba(0, 0, 0, 0) 15%, var(--fdt-semantic-color-background-primary));
  -webkit-mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 6px), #000 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 6px), #000 0);
  animation: downloadToasterSpinner 1s linear infinite;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
}

/* -------------- Variants -------------- */
.message--info {
  background: white;
  border: 1px solid var(--fdt-semantic-color-foreground-primary);
}
.message--info * {
  color: inherit;
}

.message--info-light {
  background: var(--fdt-semantic-color-background-info-light);
  border: 1px solid var(--fdt-semantic-color-border-info);
  color: var(--fdt-semantic-color-background);
}
.message--info-light * {
  color: inherit;
}

.message--success {
  background: var(--fdt-semantic-color-background-success);
  border: 1px solid var(--fdt-semantic-color-border-success);
  color: white;
}
.message--success * {
  color: inherit;
}

.message--success-light {
  background: var(--fdt-semantic-color-background-success-light);
  border: 1px solid var(--fdt-semantic-color-border-success);
  color: var(--fdt-semantic-color-background);
}
.message--success-light * {
  color: inherit;
}

.message--warning {
  background: var(--fdt-semantic-color-background-warning);
  border: 1px solid var(--fdt-semantic-color-border-warning);
  color: white;
}
.message--warning * {
  color: inherit;
}

.message--warning-light {
  background: var(--fdt-semantic-color-background-warning-light);
  border: 1px solid var(--fdt-semantic-color-border-warning);
  color: var(--fdt-semantic-color-background);
}
.message--warning-light * {
  color: inherit;
}

.message--error {
  background: var(--fdt-semantic-color-background-error);
  border: 1px solid var(--fdt-semantic-color-border-error);
  color: white;
}
.message--error * {
  color: inherit;
}

.message--error-light {
  background: var(--fdt-semantic-color-background-error-light);
  border: 1px solid var(--fdt-semantic-color-border-error);
  color: var(--fdt-semantic-color-background);
}
.message--error-light * {
  color: inherit;
}

.message__icon-circle {
  background-color: var(--fdt-semantic-color-border-success);
  border-radius: 50%;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
}
.message__icon-circle .u-icon-small {
  color: white;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXG1lc3NhZ2UiLCJzb3VyY2VzIjpbIm1lc3NhZ2Uuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0U7RUFDQTtFQUVBO0VBQ0E7RUFFQTtFQUVBO0VBRUE7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBS0o7RUFDRTtJQUNFOztFQUVGO0lBQ0U7OztBQUlKO0VBQ0U7RUFVQTtFQUtBO0VBS0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0FBS0U7RUFFSTtFQUNBOztBQVVGO0VBQ0U7OztBQUlKO0VBQ0U7RUFDQTtFQUVBOztBQUdBO0VBQ0U7OztBQTFCSjtFQUtJO0VBQ0E7RUFHQTs7QUFJRjtFQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFFQTs7QUFHQTtFQUNFOzs7QUExQko7RUFLSTtFQUNBO0VBR0E7O0FBSUY7RUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBRUE7O0FBR0E7RUFDRTs7O0FBMUJKO0VBS0k7RUFDQTtFQUdBOztBQUlGO0VBQ0U7OztBQUlKO0VBQ0U7RUFDQTtFQUVBOztBQUdBO0VBQ0U7OztBQUtOO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBRUE7RUFDQTs7QUFFQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogLS0tLS0tLS0tLS0tLS0gQmFzZSBsYXlvdXQgLS0tLS0tLS0tLS0tLS0gKi9cclxuLm1lc3NhZ2Uge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZ2FwOiAxcmVtO1xyXG5cclxuICBwYWRkaW5nOiAwLjc1cmVtIDFyZW07XHJcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tZmR0LWNvcmUtYm9yZGVycmFkaXVzLW1lZGl1bSk7XHJcblxyXG4gIGJveC1zaGFkb3c6IDAgMnB4IDZweCByZ2JhKDAsIDAsIDAsIDAuMDgpO1xyXG5cclxuICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG5cclxuICB0cmFuc2l0aW9uOiBvcGFjaXR5IDAuM3MgZWFzZSwgdHJhbnNmb3JtIDAuM3MgZWFzZTtcclxuXHJcbiAgJl9faWNvbiB7XHJcbiAgICBmbGV4LXNocmluazogMDtcclxuICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gIH1cclxuXHJcbiAgJl9fdGV4dCB7XHJcbiAgICBmbGV4OiAxIDEgYXV0bztcclxuICB9XHJcblxyXG4gIC5tZXNzYWdlX190ZXh0LS10cnVuY2F0ZSB7XHJcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xyXG4gICAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XHJcbiAgICBkaXNwbGF5OiAtd2Via2l0LWJveDtcclxuICAgIC13ZWJraXQtbGluZS1jbGFtcDogMztcclxuICAgIGxpbmUtY2xhbXA6IDM7XHJcbiAgICAtd2Via2l0LWJveC1vcmllbnQ6IHZlcnRpY2FsO1xyXG4gICAgd2hpdGUtc3BhY2U6IG5vcm1hbDtcclxuICB9XHJcblxyXG4gICZfX2FjdGlvbnMge1xyXG4gICAgZmxleC1zaHJpbms6IDA7XHJcbiAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgZ2FwOiAwLjVyZW07XHJcbiAgfVxyXG5cclxuICAmLS1mYWRlLW91dCB7XHJcbiAgICBvcGFjaXR5OiAwO1xyXG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0xMHB4KTtcclxuICB9XHJcblxyXG4gICZfX2Nsb3NlLWJ0biB7XHJcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xyXG4gICAgYm9yZGVyOiBub25lO1xyXG4gICAgY3Vyc29yOiBwb2ludGVyO1xyXG4gICAgcGFkZGluZzogMDtcclxuICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gIH1cclxufVxyXG5cclxuLy8gTG9hZGVyIHNwaW5uZXIgYW5pbWF0aW9uXHJcbkBrZXlmcmFtZXMgZG93bmxvYWRUb2FzdGVyU3Bpbm5lciB7XHJcbiAgMCUge1xyXG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XHJcbiAgfVxyXG4gIDEwMCUge1xyXG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTtcclxuICB9XHJcbn1cclxuXHJcbi5tZXNzYWdlX19pY29uLS1zcGlubmluZy1sb2FkZXIge1xyXG4gIGJhY2tncm91bmQ6IHJhZGlhbC1ncmFkaWVudChcclxuICAgICAgICBmYXJ0aGVzdC1zaWRlLFxyXG4gICAgICAgIHZhcigtLWZkdC1zZW1hbnRpYy1jb2xvci1iYWNrZ3JvdW5kLXByaW1hcnkpIDk0JSxcclxuICAgICAgICByZ2JhKDAsIDAsIDAsIDApXHJcbiAgICAgIClcclxuICAgICAgdG9wIC8gOHB4IDhweCBuby1yZXBlYXQsXHJcbiAgICBjb25pYy1ncmFkaWVudChcclxuICAgICAgcmdiYSgwLCAwLCAwLCAwKSAxNSUsXHJcbiAgICAgIHZhcigtLWZkdC1zZW1hbnRpYy1jb2xvci1iYWNrZ3JvdW5kLXByaW1hcnkpXHJcbiAgICApO1xyXG4gIC13ZWJraXQtbWFzazogcmFkaWFsLWdyYWRpZW50KFxyXG4gICAgZmFydGhlc3Qtc2lkZSxcclxuICAgIHJnYmEoMCwgMCwgMCwgMCkgY2FsYygxMDAlIC0gNnB4KSxcclxuICAgICMwMDAgMFxyXG4gICk7XHJcbiAgbWFzazogcmFkaWFsLWdyYWRpZW50KFxyXG4gICAgZmFydGhlc3Qtc2lkZSxcclxuICAgIHJnYmEoMCwgMCwgMCwgMCkgY2FsYygxMDAlIC0gNnB4KSxcclxuICAgICMwMDAgMFxyXG4gICk7XHJcbiAgYW5pbWF0aW9uOiBkb3dubG9hZFRvYXN0ZXJTcGlubmVyIDFzIGxpbmVhciBpbmZpbml0ZTtcclxuICBib3JkZXItcmFkaXVzOiA1MCU7XHJcbiAgd2lkdGg6IDJyZW07XHJcbiAgaGVpZ2h0OiAycmVtO1xyXG59XHJcblxyXG4vKiAtLS0tLS0tLS0tLS0tLSBWYXJpYW50cyAtLS0tLS0tLS0tLS0tLSAqL1xyXG5cclxuJG1lc3NhZ2UtdHlwZXM6IGluZm8sIHN1Y2Nlc3MsIHdhcm5pbmcsIGVycm9yO1xyXG5cclxuQGVhY2ggJHR5cGUgaW4gJG1lc3NhZ2UtdHlwZXMge1xyXG4gIC5tZXNzYWdlLS0jeyR0eXBlfSB7XHJcbiAgICBAaWYgJHR5cGUgPT0gaW5mbyB7XHJcbiAgICAgIGJhY2tncm91bmQ6IHdoaXRlO1xyXG4gICAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItZm9yZWdyb3VuZC1wcmltYXJ5KTtcclxuICAgIH0gQGVsc2Uge1xyXG4gICAgICBiYWNrZ3JvdW5kOiB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItYmFja2dyb3VuZC0jeyR0eXBlfSk7XHJcbiAgICAgIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLWZkdC1zZW1hbnRpYy1jb2xvci1ib3JkZXItI3skdHlwZX0pO1xyXG4gICAgfVxyXG4gICAgQGlmICR0eXBlICE9IGluZm8ge1xyXG4gICAgICBjb2xvcjogd2hpdGU7XHJcbiAgICB9XHJcblxyXG4gICAgLy8gRW5zdXJlIGFsbCBjaGlsZHJlbiBpbmhlcml0IHRoaXMgd2hpdGUgY29sb3JcclxuICAgICoge1xyXG4gICAgICBjb2xvcjogaW5oZXJpdDtcclxuICAgIH1cclxuICB9XHJcblxyXG4gIC5tZXNzYWdlLS0jeyR0eXBlfS1saWdodCB7XHJcbiAgICBiYWNrZ3JvdW5kOiB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItYmFja2dyb3VuZC0jeyR0eXBlfS1saWdodCk7XHJcbiAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItYm9yZGVyLSN7JHR5cGV9KTtcclxuXHJcbiAgICBjb2xvcjogdmFyKC0tZmR0LXNlbWFudGljLWNvbG9yLWJhY2tncm91bmQpO1xyXG5cclxuICAgIC8vIEVuc3VyZSBhbGwgY2hpbGRyZW4gaW5oZXJpdCB0aGlzIHdoaXRlIGNvbG9yXHJcbiAgICAqIHtcclxuICAgICAgY29sb3I6IGluaGVyaXQ7XHJcbiAgICB9XHJcbiAgfVxyXG59XHJcblxyXG4ubWVzc2FnZV9faWNvbi1jaXJjbGUge1xyXG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWZkdC1zZW1hbnRpYy1jb2xvci1ib3JkZXItc3VjY2Vzcyk7XHJcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xyXG4gIHBhZGRpbmc6IDAuNXJlbTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcblxyXG4gIHdpZHRoOiAycmVtO1xyXG4gIGhlaWdodDogMnJlbTtcclxuXHJcbiAgLnUtaWNvbi1zbWFsbCB7XHJcbiAgICBjb2xvcjogd2hpdGU7XHJcbiAgfVxyXG59XHJcbiJdfQ== */